import { BASEJUMP_BI_CONTRACT_ADDRESS } from '../constants';

const IS_PRODUCTION = (process.env.REACT_APP_IS_PRODUCTION || 'false').toLowerCase() === 'true'

export default class AssetModel {
  constructor(alchemyNftData, isMock = true) {
    if (isMock) {
      this.nftData = alchemyNftData;
      this.equipped = !!this.nftData.equipped;
      this.nftData.isReal = false;
      this.nftData.attributes = [];
    } else {
      this.nftData = {
        id: alchemyNftData.tokenId,
        attributes: alchemyNftData.rawMetadata.attributes.map(a => ({ name: a.trait_type, value: a.value})),
        image: alchemyNftData.rawMetadata.image,
        name: alchemyNftData.rawMetadata.name,
        description: alchemyNftData.rawMetadata.description,
        glb: alchemyNftData.rawMetadata.glb,
        type: alchemyNftData.rawMetadata.type,
        subtype: alchemyNftData.rawMetadata.subtype,
        henchie_glb: alchemyNftData.rawMetadata.henchie_glb,
        isReal: true,
      }
      this.equipped = alchemyNftData.equipped;
    }
  }
  
  isReal() {
    return !!this.nftData.isReal;
  }

  static fromAlchemyNft(alchemyNftData, isMock = true) {
    return new AssetModel(alchemyNftData, isMock);
  }

  getName() {
    return this.nftData.name;
  }

  getId() {
    return this.nftData.id;
  }

  getDescription() {
    return this.nftData.description;
  }

  getImgSource() {
    return this.nftData.image;
  }

  isEquipped () {
    return this.equipped;
  }

  getType() {
    return this.nftData.type;
  }

  getSubType() {
    return this.nftData.subtype;
  }

  getGlbSource() {
    return this.nftData.glb;
  }

  getOpenSeaLink() {
    return IS_PRODUCTION
      ? `https://opensea.io/assets/base/${BASEJUMP_BI_CONTRACT_ADDRESS}/${this.getId()}`
      : `https://testnets.opensea.io/assets/base-sepolia/${BASEJUMP_BI_CONTRACT_ADDRESS}/${this.getId()}`;
  }

  getTraits() {
    return this.nftData.attributes;
  }
};
